module.exports = __webpack_public_path__ + "img/tarj2-6.dee4c797.svg";